import React from "react";

import { Text } from "@performyard/py-components";

type BulletListSectionProps = {
	title: string;
	items: ReadonlyArray<string>;
	testId: string;
};

export const BulletListSection: React.FC<BulletListSectionProps> = ({ title, items, testId }) => {
	if (items.length === 0) return null;
	return (
		<div className="flex flex-col gap-1" data-testid={testId}>
			<Text size="paragraph-3" weight="semi-bold" color="neutral-9" overrideElement="h3">
				{title}
			</Text>
			<ul className="flex list-disc flex-col ps-5">
				{items.map((item) => (
					<li key={item}>
						<Text size="paragraph-3" color="neutral-9">
							{item}
						</Text>
					</li>
				))}
			</ul>
		</div>
	);
};
